import { FunctionComponent, ReactElement, useContext, useEffect, useState } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BaseButton, ButtonLink } from '../../components/DesignSystem';
import { GeoLoc, LoadingStatus } from '../../constants/constants';
import { useStep } from '../../hooks/useStep';
import { store } from '../../store/store';
import { ValidityHtmlElement } from '../../utils/DsType';
import { getQueryParams } from '../../utils/QueryParamsUtils';
import { Step } from '../../utils/Steps';

const FakeErrMsg = styled.span`
  margin-top: 4px;
  font-size: 14px;
  color: #c8102e;
  line-height: 20px;
  font-weight: 400;
  text-align: justify;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  margin-top: 40px;
  font-family: 'Open-sans';
  //desktop or larger
  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    base-button {
      order: 2;
    }
  }
  base-button {
    min-width: 60px;
    --light-white: var(--colors-on-primary);
    --green-50: var(--colors-primary-variant-light);
    --green-500: var(--colors-primary-default);
    --green-800: var(--colors-primary-variant-dark);
    font-family: var(--typo-form-font-family);
    font-size: var(--typo-form-font-size);
    letter-spacing: var(--typo-form-letter-spacing);
    line-height: var(--typo-form-line-height);
    font-weight: bold;
    align-self: stretch;
    --padding-button: 11px 23.5px;
  }
  base-button[disabled] {
    background-color: var(--colors-pattern-grey-300);
  }

  .backButton {
    visibility: ${(props: { currentStep: Step; apiStatus: LoadingStatus }) =>
      props.currentStep === Step.LOGEMENT ? 'hidden' : 'visible'};
    display: ${(props: { currentStep: Step; apiStatus: LoadingStatus }) =>
      props.currentStep === Step.INSURANCE && props.apiStatus === LoadingStatus.LOADING ? 'none' : 'flex'};
  }

  .trackable-next-step {
    display: ${(props: { currentStep: Step; apiStatus: LoadingStatus }) =>
      props.currentStep === Step.INSURANCE && props.apiStatus === LoadingStatus.LOADING ? 'none' : 'flex'};
  }
  .fake {
  }
`;
export interface ActionFormProps {
  currentStep: Step;
}
export const ActionFormContainer: FunctionComponent<ActionFormProps> = ({ currentStep }): ReactElement => {
  const navigate = useNavigate();
  const { state, apiStatus, geoLoc, dispatchApiStatus, dispatchGeoLoc } = useContext(store);
  const { nextStep, backStep} = useStep(currentStep);
  const [valid, setValid] = useState(false);
  const [visible, setVisible] = useState(true);
  const [fakeBtn, setFakeBtn] = useState(false);
  const [fakeBtnErr, setFakeBtnErr] = useState(false);
  const { searchParams, geoLocation } = getQueryParams();

  const [nextLabel, setNextLabel] = useState<string>('Suivant');
  useEffect(() => {
    if (geoLocation === 'cmoi' || geoLocation === 'CMOI') {
      dispatchGeoLoc(GeoLoc.CMOI);
    } else if (geoLocation === 'cmag' || geoLocation === 'CMAG') {
      dispatchGeoLoc(GeoLoc.CMAG);
    } else {
      dispatchGeoLoc(GeoLoc.CTLM);
    }
  });
  useEffect(() => {
    if (currentStep === Step.INSURANCE) {
      setNextLabel('Confirmer mon choix');
    }
  }, []);
  useEffect(() => {
    setFakeBtn(false);
    setFakeBtnErr(false);
    if (apiStatus === LoadingStatus.END_ACTION) {
      setTimeout(async () => {
        setValid(await checkFormValidity());
        setVisible(checkButtonNextVisibility());
        if (geoLoc === 'CTLM') {
          if (currentStep === 'credits') {
            if (state?.loans?.consumerLoans === undefined && state?.loans?.realEstateLoans === undefined) {
              setVisible(false);
              setFakeBtn(true);
            } else if (
              (state?.loans?.realEstateLoans?.length === 0 && state?.loans?.consumerLoans?.length === 0) ||
              (state?.loans?.consumerLoans?.length &&
                state?.loans?.consumerLoans?.reduce((s, i) => (s += i.amount), 0) === 0) ||
              (state?.loans?.consumerLoans?.length &&
                state?.loans?.consumerLoans?.reduce((s, i) => (s += i.emi), 0) === 0) ||
              (state?.loans?.realEstateLoans?.length &&
                state?.loans?.realEstateLoans?.reduce((s, i) => (s += i.amount), 0) === 0) ||
              (state?.loans?.realEstateLoans?.length &&
                state?.loans?.realEstateLoans?.reduce((s, i) => (s += i.emi), 0) === 0)
            ) {
              setVisible(false);
              setFakeBtn(true);
            } else {
              setVisible(true);
              setFakeBtn(false);
            }
          }
        }
        if (geoLoc !== 'CTLM') {
          if (currentStep === 'credits') {
            if (state?.loans?.consumerLoans === undefined) {
              setVisible(false);
              setFakeBtn(true);
            } else if (state?.loans?.consumerLoans.length === 0) {
              setVisible(false);
              setFakeBtn(true);
            } else {
              setVisible(true);
              setFakeBtn(false);
            }
          }
        }
      }, 50);
    }
  }, [state, apiStatus, currentStep]);

  const checkButtonNextVisibility = () => {
    // get html elemnt with  domtom-error class
    const domTomerrorMessage: Element | null = document.querySelector('.domtom-error');
    return !domTomerrorMessage;
  };
  const checkFormValidity = async (isNextAction = false) => {
    //get all ds input marked as validated ds
    const inputToValidate: NodeListOf<HTMLInputElement> = document.body.querySelectorAll('.to-validate');
    return await Array.from(inputToValidate).reduce(async (previous, crt: HTMLInputElement) => {
      const prevValue = await previous;
      if (window.getComputedStyle(crt, null)?.display !== 'none') {
        const valid: boolean = ((await crt.checkValidity()) as unknown as string) == 'valid';
        if (isNextAction) (crt as unknown as ValidityHtmlElement).assignValidity();
        return valid ? prevValue : false;
      }
      return prevValue ? prevValue : false;
    }, Promise.resolve(true));
  };

  const onClickBack = () => {
    if (currentStep === Step.LOGEMENT && (window as unknown as WindowWithEnv)._env_.cetelemUrl) {
      window.location.assign((window as unknown as WindowWithEnv)._env_.cetelemUrl);
    } else
      navigate({ pathname: `${process.env.PUBLIC_URL}/${backStep}`, search: `?${createSearchParams(searchParams)}` });
  };

  const onClickNext = async () => {
    //all input are valid
    if (await checkFormValidity(true)) {
      try {
        //begoin loading
        dispatchApiStatus(LoadingStatus.SAVING);

        // const res: ApiResponse = await apiClient().subscription.updateSubscription(uuid!, stepBackModel);

        // add condition by the step
        // if (res && res.statusCode === 204) {
        dispatchApiStatus(LoadingStatus.END_ACTION);
        navigate({
          pathname: `${process.env.PUBLIC_URL}/${nextStep}`,
          search: `?${createSearchParams(searchParams)}`,
        });
        // } else {
        //   throw new Error('Invalide server response');
        // }
      } catch (error) {
        dispatchApiStatus(LoadingStatus.END_ACTION);
        //TODO navigate to error page with specific code and message
      }
    }
  };
  return (
    <>
      {fakeBtn && fakeBtnErr && <FakeErrMsg>Veuillez renseigner un crédit au minimum</FakeErrMsg>}
      <Container {...{ currentStep, apiStatus }}>
        {visible && (
          <BaseButton class="trackable-next-step" clickable onClick={onClickNext} disabled={!valid || null}>
            {nextLabel}
          </BaseButton>
        )}
        {fakeBtn && (
          <BaseButton class="trackable-next-step fake" onClick={() => setFakeBtnErr(true)} disabled clickable>
            {nextLabel}
          </BaseButton>
        )}
        <ButtonLink class="backButton" onClick={onClickBack} label="Retour" />
      </Container>
    </>
  );
};
